import { BenefitCard } from './view';

export default BenefitCard;
